import * as type from '../../constants';

const initialState = {
  loading: false,
  downloadLoader: null,
  therapistList: null,
  loadingTherapistlist: false,
  recommendations: null,
  error: null
}

export function recommendationsReducer(state = initialState, action) {
  switch (action.type) {

    case type.GET_THERAPIST_LIST:
        return {
            ...state,
            loadingTherapistlist: true,
        }
    case type.GET_THERAPIST_LIST_SUCCESS:
        return {
            ...state,
            loadingTherapistlist: false,
            therapistList:action.payload,
            error: null
        }
    case type.GET_THERAPIST_LIST_FALIURE:
        return {
            ...state,
            loadingTherapistlist: false,
            therapistList: null
        }

    case type.GET_RECOMMENDATIONS:
        return {
            ...state,
            loading: true,
        }

    case type.GET_RECOMMENDATIONS_SUCCESS:
        return {
            ...state,
            loading: false,
            recommendations: action.payload,
        }

    case type.GET_RECOMMENDATIONS_FALIURE:
        return {
            ...state,
            loading: false,
            recommendations: null
        }

    case type.DOWNLOAD_RECOMMENDATIONS_EXCEL:
        return {
            ...state,
            downloadLoader: true,
        }

    case type.DOWNLOAD_RECOMMENDATIONS_EXCEL_SUCCESS:
        return {
            ...state,
            downloadLoader: false,

        }

    case type.DOWNLOAD_RECOMMENDATIONS_EXCEL_FALIURE:
        return {
            ...state,
            downloadLoader: false,
        }

    default:
      return state
  }
}

